module.exports = __webpack_public_path__ + "img/expand-arrow-down-medium.4a0fdc90.svg";